module.exports = __webpack_public_path__ + "img/close-file.9de96df6.svg";